





















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import StockCard from '@/components/stockCard/index.vue';
import StockNoData from '../stockNoData/index.vue';
import { jumpToSeeCheck, jumpToDetail, jumpToPanKou, jumpToHQ } from '../../../../common/client-agreement/jumpAgreement';
import { controllerUse } from '../../../../common/show-controller/index';
import { isJiaoYi } from '../../common/sourceConfig';

const win: any = window;
const { hxmClickStat } = win;

@Component({
  components: {
    StockCard,
    StockNoData,
  }
})
export default class StockListCard extends Vue {
  public $route: any;
  public $dialog: any;
  @Prop() private readonly data!: any; // 渲染数据
  @Prop() private readonly dataBuy!: any; // 当前用户已经购买的股票的数据
  @Prop() private readonly noDataConfig!: any; // 无数据显示文案等的配置
  @Prop() private readonly showSelect!: any; // 是否显示单选框
  @Prop() private readonly jumpConfig!: any; // 跳转地址配置
  @Prop() private readonly maidian!: any; // 埋点
  @Prop() private readonly date!: any; // 当前日期

  @Watch('data', {immediate: false, deep: true})
  getNewData(newVal: any) {
    this.dataComp = this.data;
    this.show = this.showSelect;
  };

  private dataComp: any = [];
  private name = ''; // 卡片名称
  private show = true;
  private isUse = controllerUse('hitNewStock') || win.F10Utils.getUrlParams('fromshare');


  private created() {
    this.dataComp = this.data;
    this.show = this.showSelect;
  }
  
  // 获取当前标题名称
  private getCardName(data: any, config: any) {
    if (config.showCheckUnveil) {
      return '今日中签公布'
    }
    const res = this.getDate(config);
    let stockLen = 0;
    let bondLen = 0;
    data.forEach((item: any) => {
      if (item.exchange === 'BOND') {
        bondLen++;
      } else {
        stockLen++;
      }
    });
    const stockCount = stockLen > 0 ? `新股(${stockLen})` : '';
    const bondCount = bondLen > 0 ? `新债(${bondLen})` : '';
    if (stockCount && bondCount) {
      return res + stockCount + '/' + bondCount;
    }
    return res + stockCount + bondCount;
  }

  // 是否显示可转债操作
  private handleChange(value: any) {
    hxmClickStat(this.maidian.replace('.sg', '') + '.xsxz');
    this.show = value;
    if (this.show) {
      this.$emit('changeRadio', this.show);
      return;
    }
    this.$dialog({
      title: '不显示可转债?',
      content: '选择不显示后，一键申购将不再申购可转债',
      zIndex: 1200,
      btns: [
        {
          text: '显示',
          callback: () => {
            hxmClickStat(this.maidian.replace('.sg', '') + '.xsxz.xs');
            this.show = true;
          }
        },{
          text: '不显示',
          callback: () => {
            hxmClickStat(this.maidian.replace('.sg', '') + '.xsxz.bxs');
            this.show = false;
            this.$emit('changeRadio', this.show);
          }
        }
      ]
    })
  }

  // 获取当前日期
  private getDate(config: any){
    const date = win.F10Utils.dateFormat(Number(this.date && this.date.timestamp) * 1000,'YYYYmmdd')
    if(!config.date || config.date === 'null') {
      return ''
    }
    if (config.date === date) {
      return '今日';
    }
    const res = config.date.slice(4);
    return Number(res.slice(0,2)) + '月' + res.slice(2) + '日';
  }

  // 跳转查看中签
  private handleSeeCheck() {
    hxmClickStat(`${this.maidian}`);
    jumpToSeeCheck();
  }

  // 跳转股票详情或转债盘口
  private handleSeeDetial(item: any, index: number, jumpConfig: any) {
    // 北交所埋点也分新股和新债
    // jumpToDetail(item.orderCode, jumpConfig.type, jumpConfig.fid);
    const statName = `${this.maidian}.${item.maidian}.${Number(index) + 1}`

    hxmClickStat(statName);

    // 股票代码 股票市场id 股票类型(新股new，新债bond，北交所plate) 跳转过去的tab埋点
    const stocktype = jumpConfig.type === 'bjs' ? 'bjs' : (item.exchange === 'BOND' ? 'agubond' : 'agustock');
    const tabStat = `${this.maidian.split('.').slice(0, 3).join('.')}.${item.exchange === 'BOND' ? 'xz' : 'xg'}`;
    // 申购按钮类型 today_order 当日可申购（若已申购展示查看申购记录） today_success 申购结束（中签公布）展示查看申购记录  wait_order/wait_listing 即将申购 不展示按钮
    const moduleType = jumpConfig.module;

    let jumpUrl = `//data.10jqka.com.cn/datacenterph/ipo/detail.html?code=${item.code}&marketid=${item.marketId}&module=${moduleType}&tab=${tabStat}&stocktype=${stocktype}#/`;
    if(isJiaoYi){
      jumpUrl = `//data.10jqka.com.cn/datacenterph/ipo/detail.html?source=jiaoyi&code=${item.code}&marketid=${item.marketId}&module=${moduleType}&tab=${tabStat}&stocktype=${stocktype}#/`;
    }

    win.F10Utils.jumpToLink({url:jumpUrl});
  }
}
